import { request } from '@annto/ui';
const logoutAPI = authPath + '/ssoLogout';
import { authPath, msgPath, ossPath, dsPath } from './common';
import { IMessageDetailParams, IMessageListParams, ILoginByVerificationCodeParams } from '@/utils/interface';
import http from '@/utils/http';
import store from '@/store/index';

// 只有全局的配置能够写在这里，其余的 API 统统写到自己的文件夹下面

/**
 * 退出登录
 */
export function LogoutApi(params = {}) {
  return http({
    url: logoutAPI,
    method: 'get',
    params,
  });
}

// 获取菜单
export function getList(params = []) {
  return request({
    url: authPath + 'getAllResources',
    method: 'get',
    params,
  });
}

// 获取密钥
export function getPublicKey(params = []) {
  return request({
    url: authPath + '/public/RSALogin/publicKey',
    method: 'get',
    params,
  });
}

// 账号登录
export function encSsoLogin(params = {}) {
  return http.post(authPath + '/public/encSsoLogin', params);
}

// 查询当前用户消息
export const getSelectMessage = (params: IMessageListParams) => {
  return http({
    url: msgPath + '/selectMessage',
    method: 'get',
    params,
  });
};

// 标记为已读公告
export const getMessageDetail = (data: IMessageDetailParams, id: string | number) => {
  return request({
    url: `/api-msg/message/${id}`,
    method: 'put',
    data,
  }).then((res) => res);
};

// 获取用户文件列表
export const getUserFileList = (params = {}) => {
  return http({
    url: `${ossPath}/oss/file/info/page`,
    method: 'get',
    params: params,
  });
};

// 获取验证码
export const sendVerificationCode = (params: ILoginByVerificationCodeParams) => {
  return http.post(authPath + '/public/sms/sendVerificationCodeV2', params);
};

/**
 * 登录后查找当前用户信息
 */
export function findCurrUser() {
  return http({
    url: '/api-auth/userInfo/getLogIn',
    method: 'get',
  });
}

/**
 * 登录后查询用户角色资源
 */
export function getUserRoleResources(params = {}) {
  return http({
    url: '/api-auth/public/userRoleResources',
    method: 'get',
    params,
  });
}

/**
 * 登录后获取当前租户信息
 */
export function getUserAllTenants(params: { listFlag: number; pageNo: number; pageSize: number }) {
  return http({
    url: '/api-auth/tenant/getUserAllTenants',
    method: 'get',
    params: params,
  });
}

/**
 * 获取应用
 */
export function getUserApplications(params: { userCode: any; tenantCode: any }) {
  return http({
    url: '/api-auth/getUserApplications',
    method: 'get',
    params: params,
  });
}

/**
 * 获取菜单
 */
export const getAllResources = (params: { userCode: any; applicationCode: any; tenantCode: any }) => {
  return http({
    url: '/api-auth/getAllResources',
    method: 'get',
    params: params,
  });
};

// 短信登录
export const loginBySms = (params = {}) => {
  return http({
    url: `${authPath}/public/sms/login`,
    method: 'get',
    params: params,
  });
};

// 获取应用开关配置
export function fetchSystemSwitch(applicationCode: string) {
  return http({
    url: '/api-lcp-dop/gov/resource/config/list?applicationCode=' + applicationCode,
    method: 'get',
  });
}

// 获取用户角色
export const getUserRole = (params = {}) => {
  return http({
    url: `${authPath}/public/getUserRole`,
    method: 'get',
    params: params,
  });
};

// 切换用户
export function switchAccount(params = {}) {
  return http.post(authPath + '/public/account/switch', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export function modifyMobileNum(params = {}) {
  return http.post(authPath + '/public/account/mobile/bind', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

// 获取角色组
export const getRoleGroup = (params = {}) => {
  const maintenancePageData = store.getters.maintenancePageData || {};
  return new Promise((resolve) => {
    if (maintenancePageData.init) {
      resolve({
        data: {
          list: maintenancePageData.list || [],
        },
        code: '0',
      });
      return;
    }
    http({
      url: `${dsPath}/mdmDataDictionaryDetails/page`,
      method: 'get',
      params: params,
    })
      .then((res) => {
        maintenancePageData.init = true;
        maintenancePageData.list = res && res.data ? res.data.list : [];
        store.commit('updateMaintenancePageData', maintenancePageData);
        resolve(res);
      })
      .catch(() => {
        resolve({
          data: {
            list: [],
          },
          code: '0',
        });
      });
  });
};

export const getControlParam = (params = {}) => {
  return http({
    url: `${authPath}/public/getControlParam`,
    method: 'get',
    params: params,
  });
};

// 切换租户
export const setTenant = (tenantCode: string) => {
  return request({
    url: `${authPath}/setTenant/${tenantCode}`,
    method: 'put',
  });
};
/** 字典接口响应（http 拦截器已解包为业务体，非 AxiosResponse） */
export interface DictListResponse {
  code: number | string;
  data?: Record<string, Record<string, string>>;
}

// 获取字典数据
export const getDictList = (params = {}): Promise<DictListResponse> => {
  return http({
    url: `/api-mdm/dictionaryDetail/dict`,
    method: 'get',
    params,
  }) as Promise<DictListResponse>;
};